import { render, staticRenderFns } from "./Finish23.vue?vue&type=template&id=1fcda3f1&scoped=true&"
import script from "./Finish23.vue?vue&type=script&lang=js&"
export * from "./Finish23.vue?vue&type=script&lang=js&"
import style0 from "./Finish23.vue?vue&type=style&index=0&id=1fcda3f1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcda3f1",
  null
  
)

export default component.exports